'use strict';

(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.init(root);
})(typeof window !== 'undefined' ? window : null, function () {
  var VERSION = 'dsde_v3';
  var ATTRIBUTION_MODEL = 'first-touch';
  var STORAGE_KEY = 'struga:dark-silver:attribution:v1';
  var COOKIE_KEY = 'struga_dark_silver_source';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var METRIKA_COUNTER = 108771804;
  var PROPERTY_NAME = 'properties[_struga_discovery_source]';
  var DOCUMENT_EVENTS_KEY = '__strugaDarkSilverDocumentEventsV2';
  var EVENTS = {
    view: 'dark_silver_discovery_view',
    route: 'dark_silver_route_click',
    back: 'dark_silver_back_to_hub',
    addToCart: 'dark_silver_add_to_cart',
    beginCheckout: 'dark_silver_begin_checkout'
  };
  var NEUROJOURNAL_EVENTS = {
    contentView: 'neurojournal_content_view',
    route: 'neurojournal_route_click',
    productView: 'neurojournal_product_view',
    addToCart: 'neurojournal_add_to_cart',
    beginCheckout: 'neurojournal_begin_checkout'
  };
  var NEUROJOURNAL_MARKER = 'data-struga-neurojournal-route';
  var PILOT_ARTICLES = [
    'brands-like-chrome-hearts-affordable-dark-silver',
    'dark-silver-jewelry-brands-2026',
    'hard-jewelry-review-affordable-alternative',
    'the-great-frog-guide',
    'chrome-hearts-cross-silver-cross-ring',
    'chrome-hearts-dupes-real-alternatives'
  ];
  var PILOT_SET = Object.create(null);
  var lastEvent = { key: '', at: 0 };

  PILOT_ARTICLES.forEach(function (handle) {
    PILOT_SET[handle] = true;
  });
  function isAllowedHost(hostname) {
    return hostname === 'strugadesign.com' || hostname === 'www.strugadesign.com';
  }

  function validHandle(value) {
    return (
      typeof value === 'string' &&
      value.length > 0 &&
      value.length <= 100 &&
      /^[a-z0-9][a-z0-9-]*$/.test(value)
    );
  }

  function validPilotSource(value) {
    return validHandle(value) && PILOT_SET[value] === true;
  }

  function validProbe(value) {
    return (
      typeof value === 'string' &&
      value.length >= 3 &&
      value.length <= 120 &&
      /^[a-z0-9][a-z0-9-]*$/.test(value)
    );
  }

  function validDestinationType(value) {
    return value === 'product' || value === 'collection';
  }

  function programForSource(value, declaredProgram) {
    if (declaredProgram === 'neurojournal' && validHandle(value)) {
      return 'neurojournal';
    }
    if (validPilotSource(value)) return 'dark_silver';
    return '';
  }

  function safeStorage(rootObject, kind) {
    try {
      var storage = rootObject[kind];
      var probe = '__struga_dsde_probe__';
      storage.setItem(probe, '1');
      storage.removeItem(probe);
      return storage;
    } catch (error) {
      return null;
    }
  }

  function readCookie(documentObject, name) {
    var source = String(documentObject.cookie || '').split(';');
    for (var index = 0; index < source.length; index += 1) {
      var part = source[index].trim();
      if (part.indexOf(name + '=') !== 0) continue;
      try {
        return decodeURIComponent(part.slice(name.length + 1));
      } catch (error) {
        return '';
      }
    }
    return '';
  }

  function encodeCookieAttribution(attribution) {
    if (
      attribution &&
      attribution.program === 'neurojournal' &&
      validHandle(attribution.source)
    ) {
      return [
        'n',
        attribution.source,
        validProbe(attribution.probe_id) ? attribution.probe_id : '',
        validDestinationType(attribution.destination_type)
          ? attribution.destination_type
          : '',
        validHandle(attribution.destination_handle)
          ? attribution.destination_handle
          : ''
      ].join('~');
    }
    return attribution && validPilotSource(attribution.source)
      ? attribution.source
      : '';
  }

  function writeCookie(documentObject, attribution) {
    var encoded = encodeCookieAttribution(attribution);
    if (!encoded) return false;
    try {
      documentObject.cookie =
        COOKIE_KEY +
        '=' +
        encodeURIComponent(encoded) +
        '; Max-Age=' +
        Math.floor(TTL_MS / 1000) +
        '; Path=/; SameSite=Lax; Secure';
    } catch (error) {
      return false;
    }
    return true;
  }

  function clearCookie(documentObject) {
    try {
      documentObject.cookie =
        COOKIE_KEY + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
    } catch (error) {
      return false;
    }
    return true;
  }

  function normalizeAttribution(value, timestamp) {
    if (!value || typeof value !== 'object') return null;
    var program = programForSource(value.source, value.program);
    if (
      !program ||
      typeof value.captured_at !== 'number' ||
      typeof value.expires_at !== 'number' ||
      value.expires_at <= timestamp
    ) {
      return null;
    }
    var normalized = {
      source: value.source,
      program: program,
      model: ATTRIBUTION_MODEL,
      captured_at: value.captured_at,
      expires_at: value.expires_at
    };
    if (
      program === 'neurojournal' &&
      validProbe(value.probe_id) &&
      validDestinationType(value.destination_type) &&
      validHandle(value.destination_handle)
    ) {
      normalized.probe_id = value.probe_id;
      normalized.destination_type = value.destination_type;
      normalized.destination_handle = value.destination_handle;
    }
    return normalized;
  }

  function cookieAttribution(raw, timestamp) {
    if (validPilotSource(raw)) {
      return {
        source: raw,
        program: 'dark_silver',
        model: ATTRIBUTION_MODEL,
        captured_at: timestamp,
        expires_at: timestamp + TTL_MS,
        fallback: 'cookie'
      };
    }
    var parts = String(raw || '').split('~');
    if (
      parts.length !== 5 ||
      parts[0] !== 'n' ||
      !validHandle(parts[1]) ||
      (parts[2] && !validProbe(parts[2])) ||
      (parts[3] && !validDestinationType(parts[3])) ||
      (parts[4] && !validHandle(parts[4])) ||
      Boolean(parts[3]) !== Boolean(parts[4])
    ) {
      return null;
    }
    var attribution = {
      source: parts[1],
      program: 'neurojournal',
      model: ATTRIBUTION_MODEL,
      captured_at: timestamp,
      expires_at: timestamp + TTL_MS,
      fallback: 'cookie'
    };
    if (parts[2] && parts[3] && parts[4]) {
      attribution.probe_id = parts[2];
      attribution.destination_type = parts[3];
      attribution.destination_handle = parts[4];
    }
    return attribution;
  }

  function persistAttribution(rootObject, attribution) {
    var storage = safeStorage(rootObject, 'localStorage');
    if (storage) {
      try {
        storage.setItem(STORAGE_KEY, JSON.stringify(attribution));
      } catch (error) {
        // Cookie remains the deterministic fallback.
      }
    }
    writeCookie(rootObject.document, attribution);
    return attribution;
  }

  function getAttribution(rootObject, now) {
    var timestamp = typeof now === 'number' ? now : Date.now();
    var storage = safeStorage(rootObject, 'localStorage');
    if (storage) {
      try {
        var encoded = storage.getItem(STORAGE_KEY);
        if (encoded) {
          var parsed = normalizeAttribution(JSON.parse(encoded), timestamp);
          if (parsed) return parsed;
          storage.removeItem(STORAGE_KEY);
        }
      } catch (error) {
        try {
          storage.removeItem(STORAGE_KEY);
        } catch (ignored) {
          // Storage can be revoked between calls.
        }
      }
    }

    var rawCookie = readCookie(rootObject.document, COOKIE_KEY);
    var fallback = cookieAttribution(rawCookie, timestamp);
    if (fallback) return fallback;
    if (rawCookie) clearCookie(rootObject.document);
    return null;
  }

  function captureAttribution(rootObject, source, program, route, now) {
    if (
      typeof program === 'number' &&
      typeof route === 'undefined' &&
      typeof now === 'undefined'
    ) {
      now = program;
      program = undefined;
    }
    var resolvedProgram = programForSource(source, program);
    if (!resolvedProgram) return null;
    var existing = getAttribution(rootObject, now);
    if (existing) {
      if (
        existing.source === source &&
        existing.program === 'neurojournal' &&
        route &&
        !existing.probe_id
      ) {
        existing.probe_id = route.probe_id;
        existing.destination_type = route.destination_type;
        existing.destination_handle = route.destination_handle;
        return persistAttribution(rootObject, existing);
      }
      return existing;
    }

    var timestamp = typeof now === 'number' ? now : Date.now();
    var attribution = {
      source: source,
      program: resolvedProgram,
      model: ATTRIBUTION_MODEL,
      captured_at: timestamp,
      expires_at: timestamp + TTL_MS
    };
    if (resolvedProgram === 'neurojournal' && route) {
      attribution.probe_id = route.probe_id;
      attribution.destination_type = route.destination_type;
      attribution.destination_handle = route.destination_handle;
    }
    return persistAttribution(rootObject, attribution);
  }

  function compactValue(value) {
    if (typeof value !== 'string') return value;
    return value.slice(0, 100);
  }

  function deliverAnalytics(rootObject, eventName, parameters, sinkState) {
    var payload = { portal_version: VERSION, transport_type: 'beacon' };
    var state = sinkState || { gtag: false, ym: false };
    var delivered = [];
    Object.keys(parameters || {}).forEach(function (key) {
      var value = parameters[key];
      if (value === null || typeof value === 'undefined' || value === '') return;
      payload[key] = compactValue(value);
    });

    try {
      if (state.gtag !== true && typeof rootObject.gtag === 'function') {
        rootObject.gtag('event', eventName, payload);
        state.gtag = true;
        delivered.push('gtag');
      }
    } catch (error) {
      // Analytics must never block navigation or commerce.
    }
    try {
      if (state.ym !== true && typeof rootObject.ym === 'function') {
        rootObject.ym(METRIKA_COUNTER, 'reachGoal', eventName, payload);
        state.ym = true;
        delivered.push('ym');
      }
    } catch (error) {
      // The GA4 path remains available when Metrika is blocked.
    }
    return {
      complete: state.gtag === true && state.ym === true,
      delivered: delivered,
      payload: payload
    };
  }

  function sendAnalytics(rootObject, eventName, parameters) {
    return deliverAnalytics(rootObject, eventName, parameters).payload;
  }

  function documentEventState(rootObject, key) {
    var documentObject = rootObject.document;
    var sent = documentObject[DOCUMENT_EVENTS_KEY];
    if (!sent || typeof sent !== 'object') {
      sent = Object.create(null);
      try {
        Object.defineProperty(documentObject, DOCUMENT_EVENTS_KEY, {
          configurable: false,
          enumerable: false,
          value: sent,
          writable: false
        });
      } catch (error) {
        try {
          documentObject[DOCUMENT_EVENTS_KEY] = sent;
        } catch (ignored) {
          // init's document-level guard still prevents normal duplicate loads.
        }
      }
    }
    if (!sent[key] || typeof sent[key] !== 'object') {
      sent[key] = { gtag: false, retriesScheduled: false, ym: false };
    }
    return sent[key];
  }

  function sendOncePerDocument(rootObject, key, eventName, parameters) {
    var state = documentEventState(rootObject, key);
    var result = deliverAnalytics(rootObject, eventName, parameters, state);
    return result.delivered.length > 0;
  }

  function sendOnceWhenReady(rootObject, key, eventName, parameters) {
    var delivered = sendOncePerDocument(rootObject, key, eventName, parameters);
    var state = documentEventState(rootObject, key);
    if (state.gtag === true && state.ym === true) return delivered;
    if (state.retriesScheduled || typeof rootObject.setTimeout !== 'function') {
      return delivered;
    }
    state.retriesScheduled = true;
    [250, 1000, 3000, 10000].forEach(function (delay) {
      rootObject.setTimeout(function () {
        sendOncePerDocument(rootObject, key, eventName, parameters);
      }, delay);
    });
    return delivered;
  }

  function classifyUrl(href, baseHref) {
    var url;
    try {
      url = new URL(href, baseHref);
    } catch (error) {
      return null;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    if (!isAllowedHost(url.hostname)) return null;

    var path = url.pathname.replace(/\/+$/, '') || '/';
    var patterns = [
      ['product', /^\/products\/([^/]+)$/],
      ['collection', /^\/collections\/([^/]+)$/],
      ['article', /^\/blogs\/[^/]+\/([^/]+)$/],
      ['page', /^\/pages\/([^/]+)$/]
    ];
    for (var index = 0; index < patterns.length; index += 1) {
      var match = path.match(patterns[index][1]);
      if (match) return { type: patterns[index][0], handle: match[1] };
    }
    return { type: path === '/' ? 'home' : 'other', handle: '' };
  }

  function closestElement(target, selector) {
    if (!target) return null;
    if (typeof target.closest === 'function') return target.closest(selector);
    var node = target;
    while (node) {
      if (typeof node.matches === 'function' && node.matches(selector)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function linkPosition(link) {
    var explicit = link.getAttribute('data-struga-discovery-link-position');
    if (explicit) return explicit;
    if (closestElement(link, '.struga-ap')) return 'wear_this_story';
    if (closestElement(link, '.post-navigation')) return 'article_navigation';
    if (closestElement(link, '.article-tags')) return 'article_tags';
    if (closestElement(link, '.rte')) return 'article_body';
    return 'article_other';
  }

  function neurojournalRoute(link, destination) {
    if (!link || !destination) return null;
    var probe = link.getAttribute(NEUROJOURNAL_MARKER) || '';
    if (
      !validProbe(probe) ||
      !validDestinationType(destination.type) ||
      !validHandle(destination.handle)
    ) {
      return null;
    }
    return {
      probe_id: probe,
      destination_type: destination.type,
      destination_handle: destination.handle
    };
  }

  function isExactNeurojournalRoute(link, destination) {
    return Boolean(neurojournalRoute(link, destination));
  }

  function eventForProgram(program, key) {
    if (program === 'dark_silver') return EVENTS[key] || '';
    if (program === 'neurojournal') return NEUROJOURNAL_EVENTS[key] || '';
    return '';
  }

  function neurojournalParameters(attribution, values, route) {
    var selectedRoute = route || attribution || {};
    return Object.assign(
      {
        probe_id: validProbe(selectedRoute.probe_id)
          ? selectedRoute.probe_id
          : '',
        route_source:
          attribution && validHandle(attribution.source)
            ? attribution.source
            : ''
      },
      values || {}
    );
  }

  function marker(documentObject, surface) {
    return documentObject.querySelector(
      '[data-struga-discovery-surface="' + surface + '"]'
    );
  }

  function markerHandle(element) {
    if (!element) return '';
    var value =
      element.getAttribute('data-struga-neurojournal-handle') ||
      element.getAttribute('data-struga-discovery-handle') ||
      '';
    return validHandle(value) ? value : '';
  }

  function neurojournalArticleMarker(documentObject) {
    return documentObject.querySelector(
      '[data-struga-neurojournal-surface="article"]'
    );
  }

  function markedRouteCount(documentObject, baseHref) {
    var links = documentObject.querySelectorAll(
      'a[' + NEUROJOURNAL_MARKER + '][href]'
    );
    var count = 0;
    for (var index = 0; index < links.length; index += 1) {
      var destination = classifyUrl(
        links[index].getAttribute('href'),
        baseHref
      );
      if (neurojournalRoute(links[index], destination)) count += 1;
    }
    return count;
  }

  function markDocument(documentObject, name, value) {
    try {
      if (
        documentObject.documentElement &&
        typeof documentObject.documentElement.setAttribute === 'function'
      ) {
        documentObject.documentElement.setAttribute(name, value);
      }
    } catch (error) {
      // A blocked cosmetic marker never changes attribution or commerce.
    }
  }

  function ensureAttributionInput(form, attribution) {
    var selector = 'input[name="' + PROPERTY_NAME + '"]';
    var input = form.querySelector(selector);
    if (!attribution) {
      if (input && input.getAttribute('data-struga-discovery-owned') === 'true') {
        input.parentNode.removeChild(input);
      }
      return null;
    }
    if (!input) {
      input = form.ownerDocument.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', PROPERTY_NAME);
      input.setAttribute('data-struga-discovery-owned', 'true');
      form.appendChild(input);
    }
    input.setAttribute('value', attribution.source);
    input.value = attribution.source;
    return input;
  }

  function scanProductForms(documentObject, attribution) {
    var forms = documentObject.querySelectorAll('form[action*="/cart/add"]');
    for (var index = 0; index < forms.length; index += 1) {
      ensureAttributionInput(forms[index], attribution);
    }
    return forms.length;
  }

  function deduplicatedEvent(rootObject, eventName, productHandle, parameters) {
    var now = Date.now();
    var key = eventName + ':' + productHandle;
    if (lastEvent.key === key && now - lastEvent.at < 1000) return false;
    lastEvent = { key: key, at: now };
    sendAnalytics(rootObject, eventName, parameters);
    return true;
  }

  function installProductObserver(rootObject, attribution) {
    if (typeof rootObject.MutationObserver !== 'function') return null;
    var scheduled = false;
    var schedule = function () {
      if (scheduled) return;
      scheduled = true;
      var run = function () {
        scheduled = false;
        scanProductForms(rootObject.document, attribution);
      };
      if (typeof rootObject.requestAnimationFrame === 'function') {
        rootObject.requestAnimationFrame(run);
      } else {
        rootObject.setTimeout(run, 0);
      }
    };
    var observer = new rootObject.MutationObserver(schedule);
    observer.observe(rootObject.document.body, { childList: true, subtree: true });
    rootObject.document.addEventListener('shopify:section:load', schedule);
    return observer;
  }

  function init(rootObject) {
    if (!rootObject || !rootObject.document || !rootObject.location) return false;
    if (!isAllowedHost(rootObject.location.hostname)) return false;
    if (rootObject.__strugaDarkSilverDiscoveryV1) return true;
    rootObject.__strugaDarkSilverDiscoveryV1 = true;

    var documentObject = rootObject.document;
    var discoveryArticleMarker = marker(documentObject, 'article');
    var neuroMarker = neurojournalArticleMarker(documentObject);
    var articleMarker = neuroMarker || discoveryArticleMarker;
    var productMarker = marker(documentObject, 'product');
    var articleHandle = markerHandle(articleMarker);
    var productHandle = markerHandle(productMarker);
    var routeCount =
      neuroMarker && articleHandle
        ? markedRouteCount(documentObject, rootObject.location.href)
        : 0;
    var articleProgram =
      neuroMarker && routeCount > 0
        ? programForSource(articleHandle, 'neurojournal')
        : programForSource(articleHandle);

    if (articleHandle && articleProgram) {
      captureAttribution(rootObject, articleHandle, articleProgram);
      if (articleProgram === 'neurojournal') {
        markDocument(
          documentObject,
          'data-struga-neurojournal-article',
          String(routeCount)
        );
      }
    }
    var attribution = getAttribution(rootObject);
    var attributionProgram = attribution ? attribution.program : '';
    if (articleHandle && articleProgram) {
      var articleEvent =
        articleProgram === 'neurojournal'
          ? NEUROJOURNAL_EVENTS.contentView
          : EVENTS.view;
      var articleParameters = {
        discovery_source:
          articleProgram === 'neurojournal'
            ? articleHandle
            : attribution
              ? attribution.source
              : articleHandle,
        discovery_surface: 'article',
        article_handle: articleHandle
      };
      if (articleProgram === 'neurojournal') {
        articleParameters = neurojournalParameters(
          attribution,
          Object.assign({}, articleParameters, {
            attribution_eligible: Boolean(
              attribution && attribution.source === articleHandle
            ),
            attribution_source: attribution ? attribution.source : '',
            route_count: routeCount,
            route_source: articleHandle
          })
        );
      }
      sendOnceWhenReady(
        rootObject,
        articleEvent +
          ':article:' +
          articleHandle +
          ':' +
          rootObject.location.pathname,
        articleEvent,
        articleParameters
      );
    }
    if (productHandle && attribution && attributionProgram) {
      if (attributionProgram === 'neurojournal') {
        markDocument(
          documentObject,
          'data-struga-neurojournal-attribution',
          'active'
        );
      }
      scanProductForms(documentObject, attribution);
      installProductObserver(rootObject, attribution);
      var productViewEvent =
        attributionProgram === 'neurojournal'
          ? NEUROJOURNAL_EVENTS.productView
          : EVENTS.view;
      var productParameters = {
        discovery_source: attribution.source,
        discovery_surface: 'product',
        product_handle: productHandle
      };
      if (attributionProgram === 'neurojournal') {
        productParameters = neurojournalParameters(
          attribution,
          productParameters
        );
      }
      sendOnceWhenReady(
        rootObject,
        productViewEvent +
          ':product:' +
          productHandle +
          ':' +
          rootObject.location.pathname,
        productViewEvent,
        productParameters
      );
    }

    documentObject.addEventListener(
      'click',
      function (event) {
        var backLink = closestElement(event.target, '[data-struga-discovery-back]');
        if (backLink) {
          var backDestination = classifyUrl(
            backLink.getAttribute('href'),
            rootObject.location.href
          );
          if (backDestination && attributionProgram === 'dark_silver') {
            sendAnalytics(rootObject, EVENTS.back, {
              discovery_source: attribution ? attribution.source : articleHandle,
              discovery_surface: 'product',
              product_handle: productHandle,
              destination_type: backDestination.type,
              destination_handle: backDestination.handle,
              link_position: 'product_story'
            });
          }
          return;
        }

        var checkout = closestElement(
          event.target,
          'button[name="checkout"], input[name="checkout"], button[data-struga-before-pay], a[href*="/checkout"]'
        );
        if (checkout && attribution && attributionProgram) {
          var checkoutEvent = eventForProgram(
            attributionProgram,
            'beginCheckout'
          );
          var checkoutParameters = {
            discovery_source: attribution.source,
            discovery_surface: productHandle ? 'product' : 'other',
            product_handle: productHandle
          };
          if (attributionProgram === 'neurojournal') {
            checkoutParameters = neurojournalParameters(
              attribution,
              checkoutParameters
            );
          }
          deduplicatedEvent(
            rootObject,
            checkoutEvent,
            productHandle,
            checkoutParameters
          );
          return;
        }

        if (!articleMarker || !articleHandle || !articleProgram) return;
        var link = closestElement(event.target, 'a[href]');
        if (!link) return;
        var destination = classifyUrl(
          link.getAttribute('href'),
          rootObject.location.href
        );
        if (!destination) return;
        var selectedRoute = null;
        if (articleProgram === 'neurojournal') {
          selectedRoute = neurojournalRoute(link, destination);
          if (!selectedRoute) return;
          attribution = captureAttribution(
            rootObject,
            articleHandle,
            'neurojournal',
            selectedRoute
          );
          attributionProgram = attribution ? attribution.program : '';
        }
        var routeEvent = eventForProgram(articleProgram, 'route');
        var routeParameters = {
          discovery_source:
            articleProgram === 'neurojournal'
              ? articleHandle
              : attribution
                ? attribution.source
                : articleHandle,
          discovery_surface: 'article',
          article_handle: articleHandle,
          destination_type: destination.type,
          destination_handle: destination.handle,
          link_position: linkPosition(link)
        };
        if (articleProgram === 'neurojournal') {
          routeParameters = neurojournalParameters(
            attribution,
            Object.assign({}, routeParameters, {
              attribution_eligible: Boolean(
                attribution && attribution.source === articleHandle
              ),
              attribution_source: attribution ? attribution.source : '',
              route_source: articleHandle
            }),
            selectedRoute
          );
        }
        sendAnalytics(rootObject, routeEvent, routeParameters);
      },
      true
    );

    documentObject.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (
          !productHandle ||
          !attribution ||
          !attributionProgram ||
          !form ||
          typeof form.matches !== 'function' ||
          !form.matches('form[action*="/cart/add"]')
        ) {
          return;
        }
        ensureAttributionInput(form, attribution);
        var addToCartEvent = eventForProgram(attributionProgram, 'addToCart');
        var addToCartParameters = {
          discovery_source: attribution.source,
          discovery_surface: 'product',
          product_handle: productHandle
        };
        if (attributionProgram === 'neurojournal') {
          addToCartParameters = neurojournalParameters(
            attribution,
            addToCartParameters
          );
        }
        deduplicatedEvent(
          rootObject,
          addToCartEvent,
          productHandle,
          addToCartParameters
        );
      },
      true
    );
    return true;
  }

  return {
    VERSION: VERSION,
    ATTRIBUTION_MODEL: ATTRIBUTION_MODEL,
    STORAGE_KEY: STORAGE_KEY,
    COOKIE_KEY: COOKIE_KEY,
    TTL_MS: TTL_MS,
    PROPERTY_NAME: PROPERTY_NAME,
    EVENTS: Object.assign({}, EVENTS),
    NEUROJOURNAL_EVENTS: Object.assign({}, NEUROJOURNAL_EVENTS),
    NEUROJOURNAL_MARKER: NEUROJOURNAL_MARKER,
    PILOT_ARTICLES: PILOT_ARTICLES.slice(),
    isAllowedHost: isAllowedHost,
    validHandle: validHandle,
    validProbe: validProbe,
    validDestinationType: validDestinationType,
    programForSource: programForSource,
    neurojournalRoute: neurojournalRoute,
    isExactNeurojournalRoute: isExactNeurojournalRoute,
    getAttribution: getAttribution,
    captureAttribution: captureAttribution,
    classifyUrl: classifyUrl,
    ensureAttributionInput: ensureAttributionInput,
    scanProductForms: scanProductForms,
    sendAnalytics: sendAnalytics,
    sendOncePerDocument: sendOncePerDocument,
    sendOnceWhenReady: sendOnceWhenReady,
    init: init
  };
});
